module.exports = __webpack_public_path__ + "img/radiografia3.1a109b70.jpg";